import { render, staticRenderFns } from "./WindowsCloseIcon.vue?vue&type=template&id=12afcc7b&"
import script from "./WindowsCloseIcon.vue?vue&type=script&lang=js&"
export * from "./WindowsCloseIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports